<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="「TinyTAN」期間限定イベント第4弾開始！" />
    <div>
      <div data-v-3c4f816c="" class="text-area">23.05.16<br><br>「TinyTAN」期間限定イベント 第4弾！<br><br>「Permission to
        Dance」デザインのTinyTANのキャラクターたちが、スタンプやシールになって登場！<br><br>
        <center>
          <img src="@/assets/Png/News/TinyTanPermission/TinyTAN_Permission_to_Dance_01.png" style="max-width: 100%;">
        </center>
        <br>■実施期間
        <br>2023年5月16日(火)～2023年6月19日(月)
        <br><br>■対象機種
        <br>全国の「romakyun（ろまきゅん）」
        <br><br>
        <center>
          <img src="@/assets/Png/News/TinyTanPermission/Kyoutai_romakyun.png" style="max-width:80%;">
        </center>
        <br><br>
        <center>
          <a href="https://o.puri.jp/appfw/locationRomakyun/">
            romakyunを遊べるお店はこちら<br>
          </a>
        </center>
        <br><br>■内容
        <br><br>スタンプ 全31種、シールデザイン 2種
        <br><br>
        <center>
          <img src="@/assets/Png/News/TinyTanPermission/TinyTAN_Permission_to_Dance_03.png" style="max-width: 100%;">
        </center>
        <br><br>キャラクタースタンプはタッチする度、2種類のデザインが交互に切り替わるよ♪
        <br><br>
        <center>
          <img src="@/assets/Png/News/TinyTanPermission/TinyTAN_Permission_to_Dance_02.png" style="max-width: 100%;">
        </center>
        <br>シールが出てきたら、連動アプリ「プリクラON」で
        <br>プリデータのダウンロードも忘れずに♪
        <br>ダウンロードすると、
        <br>3秒動画「モーメント」も見れるよ！
        <br>SNSにもアップしてね♪
        <br><br>プリクラONのカメラで
        <br>撮影したシールを見ると
        <br>シールが動く「ARプリクラ」も
        <br>楽しめるからこちらも試してみてね♪
        <br><br>
        <center>セガ公式SNSでも最新情報を発信中！</center>
        <br><br>■TinyTANとは
        <br><br>BTSメンバー7人が、かわいいTinyTANキャラクターとして誕生しました！
        <br>MAGICDOORを通じて現実世界を行き来するTinyTAN。
        <br>ある日突然魔法のように現れ、皆さまを癒す秘密の友だちになってくれるでしょう。
        <br><br>
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
          <a class="snsIcon" href="https://lin.ee/BncFzGc">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_03_LINE.jpg">
          </a>
          <a class="snsIcon" href="https://www.tiktok.com/@sega_purikura">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_04_TT.jpg">
          </a>
        </div>
        <div class="centerBlock">
          <a href="https://www.instagram.com/sega_purikura/">Instagram</a>
          <a href="https://twitter.com/SEGA_purikura/">X(旧Twitter)</a>
          <a href="https://lin.ee/BncFzGc">LINE</a>
          <a href="https://www.tiktok.com/@sega_purikura">TikTok</a>
          <br><br>
        </div>
        <center><b>©SEGA</b></center>
        <center><img src="@/assets/Png/News/TinyTanPermission/Legal02.png" style="max-width: 80%;"></center>
      </div>
    </div>
    <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
    <sub-btn @click="onHome()">ホームに戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

export default {
  name: "NewsDetail",
  components: { SectionHeader, SubBtn },
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  methods: {
    onNewsList() {
      this.$router.push('/newsList')
    },
    onHome() {
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
      max-width: 100%;
    }

    .edge {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.12);
    }

    p {
      margin-top: 1em;
    }

    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 15px;
      }
      &>a:nth-of-type(2){
        margin-right: 20px;
      }
    }

    .centerBlock {
      display: flex;
      justify-content: center;

      &>a:not(:last-of-type) {
        margin-right: 25px;
      }

      &>a:last-of-type {
        margin-left: 18px;
      }
    }
  }
}</style>
